import { normalize } from 'normalizr'
import { Schemas } from '@redux/schema'
import { updateEntities, deleteEntity } from '@redux/entities'

import api from '@functions/api'

import { handleError } from '../utils'

const FETCH_REQUEST = 'contenthouse/wordReplacement/FETCH_REQUEST'
const FETCH_SUCCESS = 'contenthouse/wordReplacement/FETCH_SUCCESS'
const FETCH_FAILURE = 'contenthouse/wordReplacement/FETCH_FAILURE'

const CREATE_REQUEST = 'contenthouse/wordReplacement/CREATE_REQUEST'
const CREATE_SUCCESS = 'contenthouse/wordReplacement/CREATE_SUCCESS'
const CREATE_FAILURE = 'contenthouse/wordReplacement/CREATE_FAILURE'

const UPDATE_REQUEST = 'contenthouse/wordReplacement/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'contenthouse/wordReplacement/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'contenthouse/wordReplacement/UPDATE_FAILURE'

const DELETE_REQUEST = 'contenthouse/wordReplacement/DELETE_REQUEST'
const DELETE_SUCCESS = 'contenthouse/wordReplacement/DELETE_SUCCESS'
const DELETE_FAILURE = 'contenthouse/wordReplacement/DELETE_FAILURE'

// Initial State
const initialState = {
  creating: false,
  deleting: false,
  errors: [],
  loaded: false,
  loading: false,
  updating: false,
}

// Actions
export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(){
  return {
    type: FETCH_SUCCESS,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function deleteRequest(){
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(){
  return {
    type: DELETE_SUCCESS,
  }
}

export function deleteFailure(errors = []){
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

// Action Creators
export function loadWordReplacements(){
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api('/v1/word-replacements')
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.WORD_REPLACEMENT_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess(data))

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function createWordReplacement(wordReplacement, options = {}){
  const config = {
    method: 'POST',
    data: wordReplacement,
  }

  return (dispatch) => {
    dispatch(createRequest())

    const promise = api('/v1/word-replacements', options, config)
      .then((data) => {
        const addedWordReplacement = { id: data.data, ...wordReplacement }
        const normalizedJson = normalize(addedWordReplacement, Schemas.WORD_REPLACEMENT)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(createFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function updateWordReplacement(wordReplacement, options = {}){
  const config = {
    method: 'PUT',
    data: wordReplacement,
  }

  return (dispatch) => {
    dispatch(updateRequest())

    const promise = api(`/v1/word-replacements/${wordReplacement.id}`, options, config)
      .then(({ data }) => {
        const normalizedJson = normalize(wordReplacement, Schemas.WORD_REPLACEMENT)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())
        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(updateFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function deleteWordReplacement(wordReplacement){
  const config = {
    method: 'DELETE',
  }

  return (dispatch) => {
    dispatch(deleteRequest())

    const promise = api(`/v1/word-replacements/${wordReplacement.id}`, { permanent: true }, config)
      .then(({ data }) => {
        const normalizedJson = normalize(wordReplacement, Schemas.WORD_REPLACEMENT)
        dispatch(deleteEntity(normalizedJson))
        dispatch(deleteSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(deleteFailure(errors))

        return { success: false, result: errors }
      })
    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.errors,
      }
    case CREATE_REQUEST:
      return {
        ...state,
        creating: true,
      }
    case CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        errors: [],
      }
    case CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        errors: action.errors,
      }
    case UPDATE_REQUEST:
      return {
        ...state,
        updating: true,
      }
    case UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        errors: [],
      }
    case UPDATE_FAILURE:
      return {
        ...state,
        updating: false,
        errors: action.errors,
      }
    case DELETE_REQUEST:
      return {
        ...state,
        deleting: true,
      }
    case DELETE_SUCCESS:
      return {
        ...state,
        deleting: false,
        errors: [],
      }
    case DELETE_FAILURE:
      return {
        ...state,
        deleting: false,
        errors: action.errors,
      }
    default:
      return state
  }
}
